<template>
    <div>
        <span class="block text-center text-2xl font-bold mb-8">{{ $t('internationalCertificates') }}</span>

        <template v-if="certificates.length">
            <vs-card v-for="certificate in certificates" :key="certificate.uid">
                <div :class="classForDOM.parent">
                    <span class="text-xl font-semibold mb-4">
                        {{ certificate['type_name'] }}
                    </span>
                </div>
                <div class="pl-0 md:pl-8">
                    <div :class="classForDOM.parent">
                        <span class="text-lg font-normal mb-2" style="color: black">
                            {{ $t('information') }}
                        </span>
                    </div>
                    <div :class="classForDOM.parent" class="member-information mb-4">
                        <table>
                            <tr>
                                <td class="text-base font-semibold pr-20 pb-2">
                                    {{ $t('proficiency') }}
                                </td>
                                <td class="text-base pr-4 pb-2">
                                    {{ certificate['proficiency_name'] }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-base font-semibold pr-20 pb-2">
                                    {{ $t('language') }}
                                </td>
                                <td class="text-base pr-4 pb-2">
                                    {{ certificate['language_name'] }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-base font-semibold pr-20 pb-2">
                                    {{ $t('score') }}
                                </td>
                                <td class="text-base pr-4 pb-2">
                                    {{ certificate.score }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-base font-semibold pr-20 pb-2">
                                    {{ $t('number') }}
                                </td>
                                <td class="text-base pr-4 pb-2">
                                    {{ certificate.number }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-base font-semibold pr-20 pb-2">
                                    {{ $t('issued_at') }}
                                </td>
                                <td class="text-base pr-4 pb-2">
                                    {{ certificate.issued_at?$moment(certificate.issued_at).format('DD-MM-YYYY') : $t('not_filled')}}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div :class="classForDOM.parent">
                            <span class="text-lg font-normal mb-4" style="color: black;">
                                {{ $t('attached_documents') }}
                            </span>
                    </div>
                    <div class="flex flex-col md:flex-row justify-start items-center md:items-start mb-8"
                         v-for="file in certificate.files" :key="file.uid">
                        <div class="mr-4">
                              <a :href="file.path"
                                   target="_blank">
                            <img :src="file['content_type'].indexOf('image') > -1 ? file.path : require('@/assets/images/icon_file.jpg')"
                                 alt=""
                                 class="custom-attach-image rounded shadow-md">
                              </a>
                        </div>
                        <div class="flex flex-col w-full ">
                            <span class="text-base mb-4" style="word-wrap: break-word;">{{ file.name }}</span>
                            <div class="flex flex-col w-full md:flex-row">
                              
                                    <!-- <vs-button color="warning"
                                               v-if="file['content_type'].indexOf('image') > -1 || file['content_type'].indexOf('pdf')> -1"
                                               type="relief"
                                               class="mr-0 md:mr-4 w-full md:w-auto mb-2 md:mb-0">
                                        {{ $t('open_in_new_tab') }}
                                    </vs-button>
                                </a> -->
                                <a :href="file.path" download>
                                    <vs-button type="relief"
                                                icon="file_download"
                                               class="w-full md:w-auto">
                                        {{ $t('download') }}
                                    </vs-button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex flex-col md:flex-row md:justify-end" v-if="!disabled">
                        <vs-button color="warning"
                                   type="relief"
                                   @click="editCertificate(certificate)"
                                   icon="edit"
                                   class="mb-4 md:mb-0 md:mr-4">
                            <!-- {{ $t('edit') }} -->
                        </vs-button>
                        <vs-button color="danger"
                                   type="relief"
                                   icon="delete"
                                   @click="removeCertificate(certificate)">
                            <!-- {{ $t('remove') }} -->
                        </vs-button>
                    </div>
                </div>
            </vs-card>
        </template>

        <vs-button type="relief" v-if="!disabled" @click="openModalAddInternationalCertificates">{{ $t('add_international_certificates') }}</vs-button>

        <vs-alert :title="$t('remark')"
                  active="true"
                  color="dark"
                  class="mt-4"
                  v-if="!certificates.length">
            {{ $t('international_certificates_not_required') }}
        </vs-alert>

        <vs-popup color="primary"
                  :active.sync="statusModalAddCertificates"
                  class="custom-popup"
                  :title="$t(objectForEditCertificates ? 'edit_international_certificates_title' : 'add_international_certificates_title')">
            <InternationalCertificateForm v-if="statusModalAddCertificates"
                                          :data="objectForEditCertificates"
                                          @setObjectCertificate="setObjectCertificate"
                                          :file_upload_limitation="file_upload_limitation"
                                          :profile-uid="data.profile.uid"/>

        </vs-popup>
    </div>
</template>

<script>
import InternationalCertificateForm
    from "@/pages/Home/FillingInTheApplicantsData/Declaration/components/InternationalCertificateForm";
export default {
    name: "InternationalCertificates",
    components: {
        InternationalCertificateForm,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        file_upload_limitation: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            certificates: [],
            statusModalAddCertificates: false,
            objectForEditCertificates: null,
            classForDOM: {
                grandParent: 'flex flex-col md:flex-row justify-between',
                parent: 'flex flex-col md:flex-row justify-between items-start',
                block: 'flex flex-col w-full',
            },
        }
    },
    created() {
        if(this.data.certificates){
            this.certificates = this.data.certificates
        }
    },
    methods: {
        validateStep(){
            this.$emit('setNewDataInObject', {
                name: 'certificates',
                date: this.certificates,
            })
            return true
        },
        openModalAddInternationalCertificates(){
            this.statusModalAddCertificates = true;
        },
        closeModalAddInternationalCertificates(){
            this.statusModalAddCertificates = false;
        },
        editCertificate(object){
            this.objectForEditCertificates = object;
            this.openModalAddInternationalCertificates()
        },
        setObjectCertificate(object){
            if(this.certificates.some(p => p.uid === object.uid)){
                this.certificates = this.certificates.map(p => p.uid === object.uid ? object : p)
            } else {
                this.certificates.push(object)
            }
            this.closeModalAddInternationalCertificates()
        },
        async removeCertificate(object){
            try {
                this.$vs.loading();

                await this.$http.delete(
                    `admissions/international-certificates/${ object.uid }/`
                )
                this.certificates = this.certificates.filter(c => c.uid !== object.uid)

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.member-information{
    table {
        td {
            vertical-align: top;
            min-width: 140px;
            padding-bottom: .8rem;
            word-break: break-all;
        }
        &:not(.permissions-table) {
            td {
                @media screen and (max-width: 600px) {
                    display: block;
                }
            }
        }
    }
}

.custom-attach-image{
    width: 150px;
    height: 150px;
    object-fit: cover;
}
</style>
